/**
 * Справочник должностей (задача 123 §2.1/§2.2).
 *
 * Чтение и создание открыты руководителю (гейт `PeopleManager` на бэке) —
 * должность заводится на лету из диалога найма; курирование (переименование,
 * порядок, удаление, набор работ) остаётся за админом. `POST` идемпотентен:
 * существующее имя возвращает ту же строку, а не конфликт.
 */
import { api } from "./client";
import type { components } from "./types";

export type Position = components["schemas"]["Position"];
export type CreatePositionRequest = components["schemas"]["CreatePositionRequest"];
export type PatchPositionRequest = components["schemas"]["PatchPositionRequest"];

export function listPositions(): Promise<Position[]> {
  return api.get<Position[]>("/admin/positions");
}

export function createPosition(body: CreatePositionRequest): Promise<Position> {
  return api.post<Position>("/admin/positions", body);
}

export function patchPosition(id: number, body: PatchPositionRequest): Promise<Position> {
  return api.patch<Position>(`/admin/positions/${id}`, body);
}

export function deletePosition(id: number): Promise<void> {
  return api.delete<void>(`/admin/positions/${id}`);
}

export function reorderPositions(orderedIds: number[]): Promise<void> {
  return api.post<void>("/admin/positions/reorder", { ordered_ids: orderedIds });
}

export function getPositionWorkTypeIds(id: number): Promise<number[]> {
  return api.get<number[]>(`/admin/positions/${id}/work-types`);
}

export function setPositionWorkTypeIds(id: number, ids: number[]): Promise<number[]> {
  return api.put<number[]>(`/admin/positions/${id}/work-types`, { ids });
}
